export const STATE_OVERRIDE_KEY = Object.freeze({
  AK: "fplOverrideAlaska",
  HI: "fplOverrideHawaii"
});

export const selectFplJsonByState = (stateCode, fplByKey) => {
  const code = typeof stateCode === "string" ? stateCode.trim().toUpperCase() : "";
  const overrideKey = STATE_OVERRIDE_KEY[code];
  const override = overrideKey ? fplByKey[overrideKey] : null;
  return override || fplByKey.fpl;
};
